// Datumveld met `commitOnChange` (melding oprichter 2026-10-01): wie een geboortedatum typt, kreeg
// de bevestiging "16 jaar of ouder" al vóór het jaartal af was. De native <input type="date">
// vuurt `change` zodra de deelvelden samen een geldige datum vormen, ook halverwege het typen
// (jaar 0002, 0020, 0201). Daarom: na typen pas doorgeven bij verlaten van het veld (blur) of
// Enter; een keuze in de kalender (zonder toetsaanslag) gaat meteen door. Elke waarde gaat
// hoogstens één keer door.

export interface DateCommit {
  /** De bekende (opgeslagen) waarde van de aanroeper; nieuw = opnieuw beginnen. */
  sync(value: string): void;
  /** Toetsaanslag in het veld: Enter geeft door, de rest betekent "nog aan het typen". */
  keydown(key: string, current: string, incomplete?: boolean): void;
  /** Native `change`: alleen doorgeven als er niet getypt is (kalenderkeuze). */
  change(current: string): void;
  /** Veld verlaten: wat getypt is, gaat nu door; een half ingevulde datum (badInput) niet. */
  blur(current: string, incomplete?: boolean): void;
}

/** Commit-logica los van de DOM, zodat hij zonder browser te testen is. */
export function createDateCommit(initial: string, emit: (value: string) => void): DateCommit {
  let known = initial;
  let typing = false;
  const commit = (current: string) => {
    typing = false;
    if (current === known) return;
    known = current;
    emit(current);
  };
  return {
    sync(value) {
      known = value;
      typing = false;
    },
    keydown(key, current, incomplete) {
      if (key === 'Enter') {
        if (!incomplete) commit(current);
      } else if (key !== 'Tab' && key !== 'Shift' && key !== 'Escape') typing = true;
    },
    change(current) {
      if (!typing) commit(current);
    },
    blur(current, incomplete) {
      if (incomplete) typing = false;
      else commit(current);
    },
  };
}
